import { DataTable } from 'mantine-datatable';
import { useRevenue } from '@/hooks/useRevenue';
import { formatCurrency } from '@/utils/format';

export function RevenueTable() {
  const { data: revenue, isLoading } = useRevenue();

  return (
    <DataTable
      withTableBorder
      borderRadius="sm"
      striped
      highlightOnHover
      records={revenue ?? []}
      fetching={isLoading}
      columns={[
        { accessor: 'companyName', title: 'Unternehmen', sortable: true },
        {
          accessor: 'totalRevenue',
          title: 'Gesamtumsatz',
          sortable: true,
          render: (row) => formatCurrency(row.totalRevenue, row.currency),
        },
        {
          accessor: 'monthlyRevenue',
          title: 'Letzter Monat',
          render: (row) => {
            const last = row.monthlyRevenue[row.monthlyRevenue.length - 1];
            return last ? formatCurrency(last.amount, row.currency) : '-';
          },
        },
      ]}
      noRecordsText="Keine Umsatzdaten vorhanden"
    />
  );
}
